import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import tw from "tailwind-styled-components";
import DesignationTimelineSvg from "./DesignationTimelineSVG";
import LeavePolicyGroupEditSinglePopup from "./PopUp/LeavePolicyGroupEditSinglePopup";


// Memoize to prevent unnecessary re-renders
const LeavePolicyGroupStatus = ({ list, edit, setLoading }) => {
  const { id } = useParams();
  const dispatch = useDispatch();

  // Normalize list to always be an array
  const leavePolicyGroupList = Array.isArray(list) ? list : list ? [list] : [];

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this leave policy group history?")) {
      try {
        setLoading(true);
        // Adjust based on your Redux setup
        // const { data } = await dispatch(deleteLeavePolicyGroupHistory(id));
        // if (data.message === "success") {
        //   await dispatch(loadSingleStaff(id));
        // } else {
        //   throw new Error("Failed to delete leave policy group history");
        // }
      } catch (error) {
        // console.error("Delete error:", error);
        alert("Failed to delete leave policy group history");
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div>
      <main className="container mx-auto w-full flex justify-center mt-5">
        <ol className="border-l-2 border-slate-600">
          {leavePolicyGroupList.length > 0 ? (
            leavePolicyGroupList.map((item, index) => (
              <li key={item.EmployeeLeavePolicyGroupHistoryId || index}>
                <div className="md:flex flex-start">
                  <DesignationTimelineSvg aria-hidden="true" />
                  <div className="block p-6 max-w-md ml-6 mb-5">
                    <div className="flex justify-between mb-4">
                      <Heading>{item.LeavePolicyGroupName || "Unknown"}</Heading>
                      <Heading>
                        {dayjs(item?.EffectedFrom).format("MMM YYYY")} -{" "}
                        {item?.EffectiveTo
                          ? dayjs(item?.EffectiveTo).format("MMM YYYY")
                          : "Present"}
                      </Heading>
                      {edit && (
                        <div className="flex items-center space-x-2">
                          <LeavePolicyGroupEditSinglePopup
                            data={item}
                            setLoading={setLoading}
                          />
                          {/* <button
                            onClick={() => handleDelete(item.EmployeeLeavePolicyGroupHistoryId)}
                            aria-label={`Delete ${item.LeavePolicyGroupName || "leave policy group"} history`}
                            className="text-red-600 hover:text-red-800"
                          >
                           
                            <span>🗑️</span>
                          </button> */}
                        </div>
                      )}
                    </div>
                    <Heading1>
                      Start Date:{" "}
                      <Heading2>
                        {item.EffectedFrom
                          ? dayjs(item.EffectedFrom).format("DD/MM/YYYY")
                          : "N/A"}
                      </Heading2>
                    </Heading1>
                    <Heading1>
                      End Date:{" "}
                      <Heading2>
                        {item?.EffectedTo ? dayjs(item?.EffectedTo).format("DD/MM/YYYY") : "Present"}
                      </Heading2>
                    </Heading1>
                  </div>
                </div>
              </li>
            ))
          ) : (
            <div className="p-4 text-center text-gray-500">
              No leave policy group history available
            </div>
          )}
        </ol>
      </main>
    </div>
  );
};

// Styled components
const Heading = tw.h3`
  font-medium
  text-base
  mr-20
  w-500
  txt-color-2
`;

const Heading1 = tw.h3`
  font-medium
  text-sm
  mr-20
  w-500
  txt-color-2
`;

const Heading2 = tw.span`
  font-medium 
  text-sm
  txt-color-secondary
`;

export default LeavePolicyGroupStatus;